import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Common } from '../lib/common-methods';

@Component({
  selector: 'app-color-dropdown',
  templateUrl: './color-dropdown.component.html',
  styleUrls: ['./color-dropdown.component.scss']
})
export class ColorDropdownComponent implements OnInit, OnChanges {

  constructor() { }

  @Input()
  model: string = "";
  @Output()
  modelChange = new EventEmitter<string>();

  selectedColor?: { display: string, value: string } | null = null;

  colors = [      
    { display: 'Dark Blue', value: '#012D62' },    
    { display: 'Brown', value: '#8A4813' },    
    { display: 'Teal', value: '#2E3F4F' },    
    { display: 'Pink', value: '#E1278E' },    
    { display: 'Red', value: '#C62034' },    
    { display: 'Purple', value: '#6E1ECF' },    
    { display: 'Turquoise', value: '#337277' },    
    { display: 'Lime', value: '#6A6B13' },    
    { display: 'Green', value: '#008945' },    
    { display: 'Eclipse', value: '#3D3D3D' },    
    { display: 'Blue', value: '#006CD2' },    
    { display: 'Tiber', value: '#1B4448' },    
    { display: 'Orange', value: '#F85952' },    
    { display: 'Burgundy', value: '#560934' },    
    { display: 'Grey', value: '#627A93' },    
  ];

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['model'] == null) {
      return;
    }
    const modelColor = (changes['model'].currentValue as string)?.toLocaleUpperCase();

    let color = this.colors.find(c => c.value == modelColor);
    if (color == null && !Common.isNullOrEmpty(modelColor)) {
      const newColor = { display: modelColor, value: modelColor };
      color = newColor;
      this.colors.push(newColor);
    }
    this.selectedColor = color;

    if (color == null) {
      if (this.model != null && this.model != "") {
        this.modelChange.emit('');
      }
    }
  }

  colorSelected(color: any) {
    this.selectedColor = color;
    this.modelChange.emit(color.value);
  }
}
